import { igbSendMessage } from "../utils/postMessageHelper";
import { API } from "../config/api";
import {
  requestAPI,
  commonGetRequest,
  commonPostRequest,
  getRequestWithoutUser,
  requestWithoutUser,
} from "./apiRequest";
import {
  NetworkGameCycle,
  networkGameCycle,
  NetworkStatus,
  networkStatus,
} from "../store/networkStore";
import { mReset } from "../mockup/mReset";
import { mSpin } from "../mockup/mSpin";

// 메시지 소스 타입 정의
export const MESSAGE_SOURCE = {
  IGB: "igbMessage",
} as const;

export interface ResponseData {
  compressed: boolean;
  requestId: string;
  state: string;
  data: any;
  message?: string;
}

// 메시지 타입 정의
const SLOT_MESSAGE_TYPES = {
  SPIN_ORDER: "SPIN_ORDER",
  GAME_CYCLE_START: "GAME_CYCLE_START",
  BUY_FEATURE_SPIN_ORDER: "BUY_FEATURE_SPIN_ORDER",
  PICKEM_ORDER: "PICKEM_ORDER",
  GAME_CYCLE_FINISHED: "GAME_CYCLE_FINISHED",
  GAME_CYCLE_FINISHED_RESPONSE: "GAME_CYCLE_FINISHED_RESPONSE",
  BETTING_NTF: "BETTING_NTF",
  BETTING_NTF_RESPONSE: "BETTING_NTF_RESPONSE",
  REPLAY_SPIN_ORDER: "REPLAY_SPIN_ORDER",
} as const;

export class APIHandler {
  constructor() {
    window.addEventListener("message", this.handleMessage.bind(this));
  }

  //  IGB 메시지 처리 핸들러
  private async handleMessage(event: MessageEvent): Promise<void> {
    const { source, detail } = event.data || {};
    if (source === MESSAGE_SOURCE.IGB) {
      this.handleSlotMessage(detail.type, detail.data);
      this.handleFastSpinMessage(detail.type, detail.data);
      this.handleCommonMessage(detail.type, detail.data);
    }
  }

  // 리셋 요청
  public async reset() {
    igbSendMessage("RESET_RESPONSE", mReset);
    return mReset;
  }

  /**
   * 리플레이 초기화
   */
  public async replayReset(entrySpinId: string): Promise<void> {
    return await getRequestWithoutUser(
      `${API.replay.BASE}/${entrySpinId}`,
      {},
      "REPLAY_RESPONSE"
    );
  }

  private spinCount = 0;

  // 슬롯 메시지 처리 핸들러
  private async handleSlotMessage(type: string, data: any): Promise<void> {
    // 일반 스핀 처리
    if (type === SLOT_MESSAGE_TYPES.SPIN_ORDER) {
      networkGameCycle.set(NetworkGameCycle.PLAYING);
      igbSendMessage("SPIN_PLAY", data);
      // requestAPI(API.slot.SPIN, data, "SPIN_RESULT_RESPONSE", false);

      setTimeout(() => {
        igbSendMessage("SPIN_RESULT_RESPONSE", mSpin[this.spinCount]);
        this.spinCount++;
        if (this.spinCount >= mSpin.length) {
          this.spinCount = 0;
        }
      }, 200);
    }

    // Buy Feature 스핀 처리
    if (type === SLOT_MESSAGE_TYPES.BUY_FEATURE_SPIN_ORDER) {
      networkGameCycle.set(NetworkGameCycle.PLAYING);
      igbSendMessage("SPIN_PLAY", data);
      requestAPI(API.slot.SPIN, data, "BUY_FEATURE_RESPONSE");
    }

    // Pick'em 게임 처리
    if (type === SLOT_MESSAGE_TYPES.PICKEM_ORDER) {
      igbSendMessage("PICKEM_PLAY", data);
      requestAPI(API.slot.SPIN, data, "PICKEM_RESPONSE");
    }

    // 개별 스핀 리플레이
    if (type === SLOT_MESSAGE_TYPES.REPLAY_SPIN_ORDER) {
      igbSendMessage("SPIN_PLAY", data);
      requestWithoutUser(
        API.replay.SPIN,
        { spinId: data.spinId },
        "REPLAY_SPIN_RESPONSE"
      );
    }

    // 게임 사이클 종료 처리
    if (type === SLOT_MESSAGE_TYPES.GAME_CYCLE_FINISHED) {
      if (networkStatus.get() === NetworkStatus.GRACEFUL_KICK) {
        igbSendMessage("SOCKET_FORCE_KICK");
        networkStatus.set(NetworkStatus.OFFLINE);
      }
      networkGameCycle.set(NetworkGameCycle.IDLE);
      igbSendMessage(SLOT_MESSAGE_TYPES.GAME_CYCLE_FINISHED_RESPONSE, data);
    }

    // 베팅 알림 처리
    if (type === SLOT_MESSAGE_TYPES.BETTING_NTF) {
      requestAPI(API.slot.BETTING_NTF, data, "BETTING_NTF_RESPONSE");
    }
  }

  // FAST 100 SPINS 메시지
  private async handleFastSpinMessage(type: string, data: any): Promise<void> {
    if (type === "FAST_SPIN_ORDER") {
      networkGameCycle.set(NetworkGameCycle.PLAYING);
      requestAPI(API.slot.FAST_SPIN, data, "FAST_SPIN_RESULT_RESPONSE");
    }

    if (type === "FAST_SPIN_CURRENT") {
      requestAPI(API.slot.FAST_SPIN_CURRENT, data, "SPIN_RESULT_RESPONSE");
    }

    if (type === "FAST_SPIN_SKIP") {
      requestAPI(API.slot.FAST_SPIN_SKIP, data, "FAST_SPIN_SKIP_RESPONSE");
    }
  }

  private async handleCommonMessage(type: string, data: any): Promise<void> {
    if (type === "OVERLAY_GET_REQUEST") {
      const response = await commonGetRequest(data);
      igbSendMessage(`${data.key}_RESPONSE`, response);
    }
    if (type === "OVERLAY_POST_REQUEST") {
      const response = await commonPostRequest(data);
      igbSendMessage(`${data.key}_RESPONSE`, response);
    }
  }
}
